module.exports = __webpack_public_path__ + "static/media/volume-slash.128f57f3.svg";